module.exports = "//docs.gtimg.com/slide/img/framework/workbench/ui/ai-replace-slide-mobile/ai-assistant-36679e.svg";